"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StockErrorTypes;
(function (StockErrorTypes) {
    StockErrorTypes["INIT_PAYMENT"] = "initPayment";
})(StockErrorTypes = exports.StockErrorTypes || (exports.StockErrorTypes = {}));
